import React, {useEffect, useCallback} from 'react';

export const useKeys = ({
    pad,
    setTrackToShow,
    trackToShow,
    selectedTrack
}) => {

    useEffect(() => {
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [selectedTrack, setTrackToShow, pad, trackToShow]);

    const onKey = useCallback((e) => {
        if (e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA') {
            return;
        }
        if (e.key === "e" && (e.metaKey || e.ctrlKey)) {
            let track=  pad.slotTracks.find(x => x.trackNumber === selectedTrack);
            if (track) {
                setTrackToShow(track);
            }
        }

        if (e.key === "h" && (e.ctrlKey || e.metaKey)) {
            if (trackToShow) {
                setTrackToShow(undefined);
            } else {
                let track=  pad.slotTracks.find(x => x.trackNumber === selectedTrack);
                if (track) {
                    setTrackToShow(track);
                }
            }
        }
    }, [selectedTrack, setTrackToShow, pad, trackToShow]);
};
